import React, { useEffect } from "react";
import { shallowEqual } from "react-redux";
import { Route, Router } from "react-router-dom";
import EmptyPage from "./modules/core/empty";
import history from "shared/plugins/history";
import { Loading } from "shared/components/loading/loading";
import "./themes/css/main.css";
import MenuPage from "modules/menu/menu";
import LayoutPage from "shared/components/layout/layout";
import { ConfirmModal } from "shared/components/confirm-modal/confirm-modal";
import { ToastifyComponent } from "shared/components/toastify/toastify";
import {
  CHECKOUT_ROUTE,
  EMPTY_CART_ROUTE,
  ORDER_SUCCESS_ROUTE,
  VIEW_MENU_ROUTE,
} from "shared/constants/routes";
import useFetchAppData from "shared/plugins/fetch-app-data";
import { DisplayFooterViewCart } from "modules/shared/footer-view-cart";
import CheckoutPage from "modules/checkout/checkout";
import { isMobile, isTablet } from "react-device-detect";
import OrderSuccessPage from "modules/order-success/order-success";
import { useAppSelector } from "app.hook";
import {
  mapToShoppingCartApiModel,
  selectShoppingCart,
  setShoppingCartLocalStorage,
} from "states/shopping-cart/shopping-cart.slice";
import { RootState } from "app.store";
import { SelectOrderMethodModal } from "shared/components/select-order-method-modal/select-order-method-modal";

if (process.env.NODE_ENV === "development") {
  require("./themes/css/variables.css");
}
function App() {
  const shoppingCart = useAppSelector(selectShoppingCart, shallowEqual);
  const preLoadingApp = useAppSelector(
    (state: RootState) => state.globalValue.preLoadingApp,
    shallowEqual
  );
  useEffect(() => {
    setShoppingCartLocalStorage(mapToShoppingCartApiModel(shoppingCart));
  }, [shoppingCart]);
  useFetchAppData();

  return (
    <Router history={history}>
      {process.env.NODE_ENV === "development" && (
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no,maximum-scale=1, user-scalable=no"
        ></meta>
      )}
      {preLoadingApp ? (
        <></>
      ) : (
        <>
          <LayoutPage>
            <Route path={EMPTY_CART_ROUTE} exact={true} component={EmptyPage} />
            <Route exact path={VIEW_MENU_ROUTE} component={MenuPage} />
            <Route exact path={CHECKOUT_ROUTE} component={CheckoutPage} />
            <Route
              exact
              path={`${ORDER_SUCCESS_ROUTE}`}
              component={OrderSuccessPage}
            />
          </LayoutPage>
          <DisplayFooterViewCart />
          <ConfirmModal />
          <ToastifyComponent />
          <SelectOrderMethodModal />
        </>
      )}
      <Loading />
    </Router>
  );
}

export default App;
